export const getFirstSymbol = (str: string | null): string => {
    if(!str) {
        return "";
    }
    return str.length > 0 ? str[0].toUpperCase() : "N";
}